import React, { useEffect, useState } from "react";
import parse from "html-react-parser";
import { useDispatch } from "react-redux";
import { loadingAction } from "../../Redux/Action/loadingAction";
import { markdownToHtml } from "../../Utils/markdownToHtml";

const TERMS_OF_USE_DOC = "/doc/Brigiz Platform Terms of Use.md";

const Term = () => {
  const [data, setData] = useState("");
  const dispatch = useDispatch();

  useEffect(() => {
    getCMSData();
  }, []);

  const getCMSData = () => {
    dispatch(loadingAction(true));
    fetch(encodeURI(TERMS_OF_USE_DOC))
      .then((res) => {
        if (!res.ok) throw new Error("Failed to load Terms of Use");
        return res.text();
      })
      .then((markdown) => {
        setData(markdownToHtml(markdown));
        dispatch(loadingAction(false));
      })
      .catch(() => {
        dispatch(loadingAction(false));
      });
  };

  return (
    <>
      <section className="privacy-txt">
        <div className="container">
          <div className="row">
            <div className="col-md-12 wow fadeIn legal-doc-content">
              {data ? parse(data) : null}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Term;
